import * as R from 'ramda';

import {
  ModalStep,
  ModalStepType,
} from '@atom/components/common/createEditSchemaModal/CreateEditSchemaModalContext';
import { SchemaBudgetType } from '@atom/types/schema';
import { isNilOrEmpty } from '@atom/utilities/validationUtilities';

export const MODAL_STEPS: Record<ModalStep, ModalStepType> = {
  [ModalStep.BASIC_DETAILS]: {
    value: ModalStep.BASIC_DETAILS,
    title: 'Basic Details',
  },
  [ModalStep.COST_TRACKING]: {
    value: ModalStep.COST_TRACKING,
    title: 'Cost Tracking',
  },
  [ModalStep.COST_AND_UNIT]: {
    value: ModalStep.COST_AND_UNIT,
    title: 'Cost & Unit',
  },
};

export const getModalStepsArray = (isMaterial: boolean): ModalStepType[] => {
  const steps = [
    ModalStep.BASIC_DETAILS,
    ModalStep.COST_TRACKING,
    ...(isMaterial ? [ModalStep.COST_AND_UNIT] : []),
  ];

  return steps.map(step => MODAL_STEPS[step]);
};

export const getStepIndex = (step: ModalStep, steps: ModalStepType[]): number =>
  R.findIndex(R.propEq(step, 'value'), steps);

interface ValidationData {
  STEPS_ARRAY: ModalStepType[];
  activeStep: ModalStep;
  name: string;
  costType: SchemaBudgetType;
  rate: number | null;
  unit: string;
}

export const isCurrentStepDisabled = ({
  STEPS_ARRAY,
  activeStep,
  name,
  costType,
  rate,
  unit,
}: ValidationData): boolean => {
  const stepDisabledRules = {
    [ModalStep.BASIC_DETAILS]: isNilOrEmpty(name),
    [ModalStep.COST_TRACKING]: false,
    [ModalStep.COST_AND_UNIT]:
      (costType === SchemaBudgetType.FIXED &&
        (R.isNil(rate) || isNilOrEmpty(unit))) ||
      (costType === SchemaBudgetType.VARIABLE_COST && isNilOrEmpty(unit)),
  };

  const currentStepIndex = getStepIndex(activeStep, STEPS_ARRAY);

  const stepsToValidate = R.dropLast(
    STEPS_ARRAY.length - currentStepIndex - 1,
    STEPS_ARRAY,
  );

  return R.any(step => stepDisabledRules[step.value], stepsToValidate);
};
